import type { ComponentProps } from "react";

import { cn } from "./cn";

// A titled block of a page. Compose: Card > CardHeader (CardTitle, CardDescription) > CardContent > CardFooter.
// `CardTitle` is an `h2` unless `as` says otherwise: keep the heading order of the page.

export function Card({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn("rounded-lg border border-hairline bg-card text-card-foreground", className)}
      {...props}
    />
  );
}

export function CardHeader({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("grid gap-1 p-4 sm:p-5", className)} {...props} />;
}

export function CardTitle({
  className,
  as: Heading = "h2",
  ...props
}: ComponentProps<"h2"> & Readonly<{ as?: "h2" | "h3" | "h4" }>) {
  return (
    <Heading
      className={cn("m-0 font-serif text-[22px] leading-7 font-medium", className)}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }: ComponentProps<"p">) {
  return <p className={cn("m-0 text-sm leading-6 text-muted-foreground", className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn("grid gap-3.5 p-4 pt-0 sm:p-5 sm:pt-0", className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn("flex flex-wrap items-center gap-2 p-4 pt-0 sm:p-5 sm:pt-0", className)}
      {...props}
    />
  );
}
